import { render, staticRenderFns } from "./NetWorthStatementDemo.vue?vue&type=template&id=a63d33ae&scoped=true"
import script from "./NetWorthStatementDemo.vue?vue&type=script&lang=js"
export * from "./NetWorthStatementDemo.vue?vue&type=script&lang=js"
import style0 from "./NetWorthStatementDemo.vue?vue&type=style&index=0&id=a63d33ae&prod&scoped=true&lang=css"
import style1 from "./NetWorthStatementDemo.vue?vue&type=style&index=1&id=a63d33ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63d33ae",
  null
  
)

export default component.exports